import React from 'react';
import {Editor, EditorState,ContentState, convertToRaw,convertFromRaw} from 'draft-js';
import './editorPad.css'
import {showErrorMsg} from "./utils/commonFunc";
import {fetchGet} from "./utils/fetchData";
import {message} from 'antd'
import MobanItem from './MoudleWork/MobanItem'
import ReactAwesomePlayer from 'react-awesome-player'
import Close_Page from './imageSrc/closePreview.png';

function getBlockStyle(blockName){
    switch(blockName.getType()){
        case 'unstyled' :
            return 'RichEditor-blockquote';
        default:
            return null;
    }
}

class EditorPad extends React.Component {
    constructor(props) {
        super(props);
        this.timmer = null;
        this.lastFenciWord = '';
        this.state = {
            editorState: EditorState.createEmpty(),
            textLength:0,
            normalEditor: true,
            mobanList: [],

            popup_div: false,
            options: {
              playbackRates: [1, 1.5, 2, 2.5, 3, 5],
              controls: true,
              autoplay: true,
              // poster: "http://pic2.52pk.com/files/130514/1283314_143556_2145.jpg",
              sources: [{
                type: "video/mp4",
                src: "/Untitled.mov"
              }],
              // subtitles: [{
              //     language: 'zh',
              //     url: "https://feawesome.github.io/react-awesome-player/zh.vtt",
              //     label: "中文"
              //   },
              //   {
              //     language: 'en',
              //     url: "https://feawesome.github.io/react-awesome-player/en.vtt",
              //     label: "EN"
              // }],
              // defaultSubtitle: 'en'
            }
        };
        this.setEditor = (editor) => {
            this.editor = editor;
        };
        this.focusEditor = () => {
            if (this.editor) {
                this.editor.focus();
            }
        };

        this.closePopup = this.closePopup.bind(this);
        this.openPopup = this.openPopup.bind(this);
    }

    closePopup() {
        this.setState({
            popup_div: false,
        });

        this.refs.videoPlayerRef.player.pause();
    }

    openPopup() {
        this.setState({
            popup_div: true,
        });
    }

    loadeddata() {
      console.log('loadeddata')
    }
    canplay() {
      console.log('canplay')
    }
    canplaythrough() {
      console.log('canplaythrough')
    }
    play() {
      console.log('play')
    }
    pause() {
      console.log('pause')
    }
    waiting() {
      console.log('waiting')
    }
    playing() {
      console.log('playing')
    }
    ended() {
      console.log('ended')
    }
    error() {
      console.log('error')
    }

    setMoudleItems = (moudleItems) => {
        let mobanList = moudleItems.map((item) => {
            return {
                ...item,
                highlight: false,
            }
        });
        this.setState({
            normalEditor: false,
            mobanList: mobanList,
        });
        this.refs.fileName.value = "";
    }

    getWord = () => {

        var userSelection
        if (window.getSelection) {//一般浏览器
            userSelection = window.getSelection();
        } else if (document.selection) {//IE浏览器、Opera
            userSelection = document.selection.createRange();
        }
        if (userSelection.toString().length !== 0) {
            this.props.searchKeyWord(userSelection.toString(),false)
        }

    };

    onChange = (editorState) => {
        // let temp = convertToRaw(editorState.getCurrentContent());
        // console.log(temp.blocks[0].text);
        // temp.blocks[0].text = 'wangxiyan';
        // let temp2 = convertFromRaw(temp);


        if (!this.getWhetherScreenWord(editorState)) {
            this.clearTimeIn();
            let textLength = editorState.getCurrentContent().getPlainText().length;
            this.setState({editorState,textLength});
            var strSele = editorState.getSelection().getEndOffset()
            this.getCurrentFocusSentence(editorState,strSele);
        }
    };

    getWhetherScreenWord = (editorState)=> {
        console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%');
        var selection = editorState.getSelection();
        var startOffset = selection.getStartOffset();
        var focusOffset = selection.getFocusOffset();
        var endOffset = selection.getEndOffset();
        this.setState({
            editorState:editorState
        });

        if (startOffset !== focusOffset || endOffset !== focusOffset) {
            return true
        }
        return false
    }

    showtext = (editorState) => {
        var selectionState = editorState.getSelection();
        var anchorKey = selectionState.getEndKey();
        var endOffset = selectionState.getEndOffset();
        var currentContent = editorState.getCurrentContent();
        var currentContentBlock = currentContent.getBlockForKey(anchorKey);
        var selectedText = currentContentBlock.getText().slice(0, endOffset);
        return selectedText
    };

    ////得到光标的位置，得到最后一句话，然后请求分词
    getCurrentFocusSentence = (editState,foucus) => {
        var upperText = this.showtext(editState);
        if (upperText !== undefined && upperText.length !== 0) {
            var lastSententce = upperText.split('。').pop();
            if (this.lastFenciWord !== lastSententce) {
                this.lastFenciWord = lastSententce;
                this.timmer = setInterval(() => {
                    this.requestFenci(lastSententce);
                },2000);
            }
        }

    };

    //////////handle fenci ///////////////////////
    toGetFenciResult = (currentSentence) => {
        let lastWord = this.getLastSententce(currentSentence);
        if (this.lastFenciWord !== lastWord && lastWord !== undefined && lastWord.length !== 0) {
            this.lastFenciWord = lastWord;
            this.timmer = setInterval(() => {
                this.requestFenci(lastWord);
            },3000);
        }
    };

    getLastSententce = (currentSentence)=> {
        var content = currentSentence.split('。');
        let lastSentence = content.pop();
        return lastSentence;
    };

    clearTimeIn = ()=> {
        if (this.timmer != null) {
            clearInterval(this.timmer)
        }
    };

    requestFenci = (fenciTemp) => {
        this.clearTimeIn();
        if (fenciTemp !== undefined && fenciTemp.length !== 0) {
            let params = {fenci:fenciTemp};
            fetchGet('fenci',params,null)
                .then(data => {
                    if (data.code === 200) {
                        this.props.toAnalyseFenci(data.data)
                    }
                    else {
                        showErrorMsg(data);
                    }
                });
        }

    };
    //////////handle fenci end///////////////////////

    componentDidMount() {
        this.props.triggerRef(this);
        this.focusEditor();
    }

    updataText = (content,fileName) => {
        // console.log('========================');
        //
        // let temp = convertToRaw(this.state.editorState.getCurrentContent());
        //
        // temp.blocks[0].text = content;
        // console.log(temp);
        // console.log('========================');
        // let temp2 = this.state.editorState.getCurrentContent().createFromText(content,'\n');
        let editorState = EditorState.createWithContent(
            ContentState.createFromText(content));
        let textLength = content.length;
        // console.log('========================');
        this.setState({editorState,textLength,normalEditor: true,});

        this.refs.fileName.value = fileName;
    };

    changeVideo = (videoUrl)=> {
        this.setState({
            options: {
              sources: [{
                  type: "video/mp4",
                  src: videoUrl
                }]
              }
        });
        this.openPopup();
    }

    itemClick = (index)=> {
        let list = this.state.mobanList;
        list.forEach(item=>{
            item.highlight = false;
        })
        list[index].highlight = true;
        this.setState({
            mobanList:list
        })
    }

    getEditContent = ()=> {
        if (this.state.normalEditor) {
            return this.state.editorState.getCurrentContent().getPlainText();
        }
        else{
            var text = '';
            this.state.mobanList.map((item, index) => {

                // let title = document.getElementById('title_' + item.module_id).value;
                let body = document.getElementById('body_' + item.module_id).textContent;
                // console.log(title);
                console.log(body);
                // text += title + '\n';
                text += body + '\n';
            });
            return text;
        }


        // let contentState = convertToRaw(this.state.editorState.getCurrentContent());
        // let realContent = convertFromRaw(contentState);

    };

    getFileName = () => {
        return this.refs.fileName.value;
    };

    ///////// handle style /////////////
    getMainFrameMleft = () => {
        return this.props.isConsultVisible?36 + '%':4.35 + '%';
    };
    getMainFrameWidth = () => {
        return this.props.isConsultVisible?34.55 + '%':66.3 + '%';
    };

    getEditAreaMLeft = () => {
        return this.props.isConsultVisible?3 + 'vw':33 + 'vw';
    };
    getEditAreaWidth = () => {
        return this.props.isConsultVisible?30.75 + 'vw':32 + 'vw';
    };

    getEditAreaMTop = () => {
        return this.props.isConsultVisible?10 + '%':6 + '%';
    };
    ///////// handle style end/////////////

    getPageCount = () => {
        if (this.state.textLength === 0)
            return 0;
        return Math.floor(this.state.textLength / 550 + 1);
    };

    render(){
        return(
            <div className='div_outSide_style' style={{marginLeft:this.getMainFrameMleft(),width:this.getMainFrameWidth()}}>
                <div className='consult_top' style={{marginLeft:this.getEditAreaMLeft(),width:this.getEditAreaWidth()}}  >
                    <h6 className='counting left'>总字数:{this.state.textLength}</h6>
                    <h6 className='counting right'>约{this.getPageCount()}页</h6>
                </div>

                <input ref='fileName' placeholder='请输入文章标题' className='title' style={{marginLeft:this.getEditAreaMLeft(),width:this.getEditAreaWidth()}} />

                <div
                    onSelect={this.getWord} className='div_editor_style'
                     style={{display:this.state.normalEditor?'block':'none',marginLeft:this.getEditAreaMLeft(),width:this.getEditAreaWidth(),marginTop:this.getEditAreaMTop()}}
                     onClick={this.focusEditor}>
                    <Editor
                        ref={this.setEditor}
                        editorState={this.state.editorState}
                        onChange={this.onChange}
                        blockStyleFn={getBlockStyle}
                        placeholder={'在此处输入正文'}
                    />
                </div>

                <div className="popup_player_backgroud" style={{display: this.state.popup_div ? 'block': 'none'}}/>
                <div className="popup_player"  style={{display: this.state.popup_div ? 'block': 'none'}}>
                    <div className="popup_player_content">
                          <ReactAwesomePlayer
                            ref='videoPlayerRef'
                            options={this.state.options}
                            loadeddata={this.loadeddata}
                            canplay={this.canplay}
                            canplaythrough={this.canplaythrough}
                            play={this.play}
                            pause={this.pause}
                            waiting={this.waiting}
                            playing={this.playing}
                            ended={this.ended}
                            error={this.error}
                          />
                    </div>
                    <img onClick={this.closePopup} className='popup_player_close' src={Close_Page}/>
                    <div className="popup_player_align"/>
                </div>

                <div style={{display:this.state.normalEditor?'none':'block', height:80+'%'}}>
                    <div className='marginTop6' style={{marginLeft:this.getEditAreaMLeft(),width:this.getEditAreaWidth()}}>

                    {
                        this.state.mobanList.map((item, index) => {
                            return <MobanItem key={item.module_id} data={item} itemIndex={index} itemClick={this.itemClick.bind(this)} playVideo={this.changeVideo.bind(this)} />
                        })
                    }
                    </div>
                </div>
            </div>
        );
    }
}

export default EditorPad
